const productSlider = () => {
    const $dataGroups = document.querySelectorAll('[data-groups]');

    $dataGroups.forEach(item => {
        $(item).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            centerMode: true,
            infinite: false,
            dots: true,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            nextArrow: '<button class="slick-next slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            variableWidth: true,
        });
    });
};

export default productSlider;



// WEBPACK FOOTER //
// ./src/scripts/components/products/productSlider.js